import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { Metamodel } from 'app/model/base/model';
import { TabularTypeDatasetAdapter, tabularTypeDatasetAdapts } from './tabular-type.dataset.adapter';
import { SapTableDataset } from 'app/model/dataset/sap-table.dataset';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(SapTableDataset),
    asynchronous: true,
    adapts: tabularTypeDatasetAdapts
})
export class SapTableDatasetAdapter extends TabularTypeDatasetAdapter<SapTableDataset, Model.DatasetResource> {
    protected async _toResource(dataset: SapTableDataset): Promise<Model.DatasetResource> {
        return await this._toResourceInternal(dataset, Metamodel.modelFor(SapTableDataset).name);
    }

    protected async _toModel(modelDatasetResource: Model.DatasetResource, dataset?: SapTableDataset): Promise<SapTableDataset> {
        return await this._toModelInternal(modelDatasetResource, dataset, SapTableDataset.MODEL);
    }
}
